export default __webpack_public_path__ + "static/media/reviewer-2.dd0cfef9.png";